import { Component, EventEmitter, Input, Output } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'icons-dropdown',
  templateUrl: 'icons-dropdown.component.html',
  styleUrls: ['icons-dropdown.component.scss'],
})
export class IconsDropdownComponent {

  @Input() darkStyle: boolean = true;

  @Input() menu: Array<any>;

  @Input() iconOnRight: boolean = false;

  @Input() arrowColor: string = '';

  @Input() alignmentRight: boolean = false;

  @Input() borderHover: boolean = false;

  @Input() height: number;

  @Output() selectOption = new EventEmitter<string>();

  onItemClick(item: any) {
    this.selectItem(item);
  }

  selectItem(item: any): void {
    const selected = this.menu.find(_item => _item.active);
    if (selected) {
      selected.active = false;
    }
    item.active = true;
    this.selectOption.emit(item);
  }

  setActive(id: any): void {
    const item = this.menu.find((_item: any) => _item.id === id);
    if (item) {
      this.selectItem(item);
    }
  }
}
